import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

interface MissingTranslation {
  FileName: string;
  EnglishName: string;
  TranslatedValue: string;
  AddedManualy: boolean;
}

/**
 * @deprecated Cette page n'est pas utilisée : les traductions sont dans le fichier .lge du serveur maintenant
 */

@Component({
  selector: 'app-traduction',
  templateUrl: './traduction.component.html',
  styleUrls: ['./traduction.component.css']
})
export class TraductionComponent implements OnInit {

  currentLanguage: string = '';
  currentTranslation: any;

  arrayMissingTranslation: MissingTranslation[] = [];

  constructor(private http: HttpClient, private translate: TranslateService) { }

  ngOnInit(): void {
    try {
      this.currentLanguage = this.translate.store.currentLang;
      this.currentTranslation = this.translate.store.translations[this.translate.store.currentLang];
      this.parseTranlation();
    } catch (error) {
      console.error(error);
    }
    this.translate.onLangChange.subscribe((val: LangChangeEvent) => {
      this.currentLanguage = val.lang;
      this.currentTranslation = val.translations;
      this.parseTranlation();
    });
  }

  addMissingTrad() {
    this.arrayMissingTranslation.unshift({
      FileName: this.currentLanguage,
      EnglishName: '',
      TranslatedValue: '',
      AddedManualy: true
    });
  }

  prepareFileMissingTrad() {
    // On prepare le json pour la traduction
    const missingTranslation: any = {};
    this.arrayMissingTranslation.forEach(val => {
      if (val.EnglishName && val.TranslatedValue)
        missingTranslation[val.EnglishName] = val.TranslatedValue;
    });

    const data = JSON.stringify(missingTranslation);
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'translation ' + this.currentLanguage + '.json';
    // start download
    a.click();
  }

  private parseTranlation() {
    this.arrayMissingTranslation.length = 0;
    for (const key in this.currentTranslation) {
      if (Object.prototype.hasOwnProperty.call(this.currentTranslation, key)) {
        const element = this.currentTranslation[key];
        if (key && !element) {
          this.arrayMissingTranslation.push({
            FileName: this.currentLanguage,
            EnglishName: key,
            TranslatedValue: '',
            AddedManualy: false
          });
        }
      }
    }
  }
}
